// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 21:05:02

export default {
  "id": "animal-merge-bubble-shooter",
  "slug": "animal-merge-bubble-shooter",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/fdc2d7e2832141c3a197dc8d47296b06-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/fdc2d7e2832141c3a197dc8d47296b06/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Animal Merge: Bubble Shooter",
      "description": "Welcome to Animal Merge, where you evolve adorable creatures by merging bubbles! Launch, connect, and combine animal bubbles to create advanced species. Watch as identical animals merge into exciting new forms! Keep merging to reach the ultimate evolution and complete your goal. Use special tools to boost progress. With each level, the challenge grows—can you master merging and collect all the final animals? Jump in and start merging now!",
      "instructions": "To play Animal Merge, tap an animal bubble to select it, drag backward to aim, and release to launch. When two identical bubbles collide, they merge into an upgraded version. Keep merging to evolve creatures until you reach the final one!",
      "genres": [
        "Bubble Shooter",
        "Merge"
      ],
      "tags": [
        "animal",
        "bubble",
        "cute",
        "skill"
      ]
    },
    "zh-CN": {
      "title": "动物融合：泡泡射击",
      "description": "欢迎来到动物融合，在这里你将通过合并气泡进化可爱的生物！发射、连接、组合动物气泡，创造出高级物种。观察相同动物融合成令人兴奋的新形态！继续融合，达到终极进化并完成你的目标。使用特殊工具提升进度。随着每一关的进行，挑战不断升级——你能掌握融合并收集所有最终动物吗？跳进来开始融合吧！",
      "instructions": "要玩《动物融合》，点击一个动物泡泡选择它，向后拖动以瞄准，释放以发射。当两个相同的泡泡相撞时，它们会融合成升级版本。继续融合，进化生物直到达到最终形态！",
      "genres": [
        "泡泡射击",
        "合并"
      ],
      "tags": [
        "动物",
        "泡泡",
        "可爱",
        "技能"
      ]
    },
    "zh-TW": {
      "title": "動物合體：泡泡射擊",
      "description": "歡迎來到動物合體，一個透過合體泡泡進化可愛生物的遊戲！發射、連接並合體動物泡泡，創造先進種族。觀察相同動物合體成為令人興奮的新形態！持續合體以達到最終進化並完成你的目標。使用特殊工具來加強進度。隨著每個關卡，挑戰不斷增加——你能夠精通合體並收集所有最終動物嗎？跳進來開始合體吧！",
      "instructions": "要玩動物合體，請點擊一個動物泡泡來選擇它，向後拖動以定位，然後釋放來發射。當兩個相同的泡泡相撞時，它們會合體成為升級版本。持續合體以進化生物，直到達到最終版本！",
      "genres": [
        "泡泡射手",
        "合併"
      ],
      "tags": [
        "動物",
        "泡泡",
        "可愛",
        "技能"
      ]
    },
    "zh-HK": {
      "title": "動物合體：泡泡射手",
      "description": "歡迎來到動物合體，一個透過合體泡泡進化可愛生物的遊戲！發射、連接並合體動物泡泡，創造先進種族。觀看相同動物合體成為令人興奮的新形態！繼續合體以達到最終進化並完成目標。使用特殊工具以提升進度。隨著每個關卡，挑戰越來越大——你能夠掌握合體並收集所有最終動物嗎？加入我們，開始合體吧！",
      "instructions": "玩動物合體，請點擊一個動物泡泡來選擇它，向後拉來定位，然後放手發射。當兩個相同的泡泡相撞時，它們會合並成一個升級版本。持續合並，直到達到最後一個生物！",
      "genres": [
        "泡泡射擊",
        "合併"
      ],
      "tags": [
        "動物",
        "泡泡",
        "可愛",
        "技能"
      ]
    },
    "ja": {
      "title": "動物融合：バブルシューターの翻译是：\n動物融合：バブルシューター",
      "description": "欢迎来到Animal Merge！ここでは、バブルを合体させて可愛い生き物を進化させましょう。リリースし、接続し、動物のバブルを組み合わせて高度な種を創り出しましょう。同じ動物が興味深い新しい形に合体するのを見てください！合体を続けて究極の進化に達し、目標を達成しましょう。特別なツールを使って進捗を促進してください。レベルごとに挑戦が増えていきます—合体をマスターして最後の動物を収集できますか？ジャンプして今すぐ合体を始めましょう！",
      "instructions": "Animal Mergeをプレイするには、動物のバブルをタップして選択し、後ろに引いて的に合わせ、リリースして発射します。同じバブルが衝突すると、アップグレードされたバブルに合体します。合体を続けて、最終的なものに進化するまで生物を進化させます！",
      "genres": [
        "バブルシュータ",
        "マージ"
      ],
      "tags": [
        "動物",
        "泡",
        "可愛い",
        "スキル"
      ]
    },
    "ko": {
      "title": "동물 합성: 바블 쏘터",
      "description": "안녕하세요 애니멀 메이지에 오신 것을 환영합니다! 퍼블루스를 합쳐 귀엽고 멋진 생물을 진화시키세요! 발사하고 연결하고 동물 퍼블루스를 합쳐 고급 종을 만들어보세요. 같은 동물이 흥미로운 새로운 형태로 합쳐지는 것을 관찰하세요! 합쳐서 최종 진화에 도달하고 목표를 완성하세요. 특별 도구를 사용하여 진행을 촉진하세요. 각 레벨마다 도전이 커지죠—합쳐서 마스터하고 최종 동물을 모두 수집할 수 있을까요? 뛰어들고 합쳐서 시작하세요!",
      "instructions": "동물 합성을 플레이하려면, 동물 부분을 탭하여 선택하고, 목표지점으로 밀어내려서 방향을 잡고, 풀어서 발사하세요. 두 개의 같은 부분이 충돌하면, 업그레이드된 버전으로 합성됩니다. 최종 부분에 이르기까지 합성하여 생물을 진화시켜보세요!",
      "genres": [
        "버블 쏘터",
        "합성"
      ],
      "tags": [
        "동물",
        "퍼프",
        "귀여운",
        "기술"
      ]
    },
    "fr": {
      "title": "Animal Merge : Tire-Boule",
      "description": "Bienvenue dans Animal Merge, où vous évoluez des créatures adorables en fusionnant des bulles ! Lancez-vous, connectez-vous et combinez les bulles animales pour créer des espèces avancées. Regardez les animaux identiques se fusionner pour former des formes nouvelles et excitantes ! Continuez à fusionner pour atteindre l'évolution ultime et compléter votre objectif. Utilisez des outils spéciaux pour accélérer votre progression. Avec chaque niveau, le défi s'intensifie — pouvez-vous maîtriser la fusion et collecter tous les animaux finals ? Plongez et commencez à fusionner maintenant !",
      "instructions": "Pour jouer à Animal Merge, appuyez sur une bulle animale pour la sélectionner, faites glisser vers l'arrière pour viser, puis relâchez pour lancer. Lorsque deux bulles identiques se touchent, elles fusionnent pour former une version améliorée. Continuez à fusionner pour évoluer les créatures jusqu'à atteindre la dernière !",
      "genres": [
        "Tir de Bulles",
        "Fusion"
      ],
      "tags": [
        "animal",
        "bulle",
        "mignon",
        "compétence"
      ]
    }
  }
};
